import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Button } from "src/components/common"
import { track } from "src/utils/track"
import { scrollToAnchor } from "src/utils/scroll"
import {
  Hero,
  Inner,
  Copy,
  Overline,
  Frame,
  Subline,
  Actions,
  Trust,
  Availability,
  Brands,
  Portrait,
} from "./styles"

export const Intro = () => {
  const { t } = useTranslation()
  const data = useStaticQuery(graphql`
    query {
      portrait: file(relativePath: { eq: "potrait-stefanhelker-shape.png" }) {
        childImageSharp {
          fluid(
            maxWidth: 520
            quality: 85
            sizes: "(min-width: 992px) 460px, 280px"
          ) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Hero aria-labelledby="hero-title">
      <Inner as={Container}>
        <Copy>
          <Overline>{t("header:overline")}</Overline>
          <Frame>
            <h1 id="hero-title">{t("header:title")}</h1>
          </Frame>
          <Subline>{t("header:subline")}</Subline>
          <Actions id="hero-cta">
            <Button
              href="#contact"
              onClick={event => {
                track("cta_click", { location: "hero" })
                scrollToAnchor(event)
              }}
            >
              {t("header:cta_primary")}
            </Button>
            <Button
              $variant="secondary"
              href="#references"
              onClick={scrollToAnchor}
            >
              {t("header:cta_secondary")}
            </Button>
          </Actions>
          <Trust>
            <Availability>
              <span aria-hidden="true" />
              {t("header:availability")}
            </Availability>
            <Brands>
              <strong>{t("header:trust_label")}</strong>{" "}
              {t("header:trust_brands")}.
            </Brands>
          </Trust>
        </Copy>
        <Portrait>
          <Img
            fluid={data.portrait.childImageSharp.fluid}
            alt={t("header:portrait_alt")}
          />
        </Portrait>
      </Inner>
    </Hero>
  )
}
